var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6248 4.73002C17.637 4.90057 17.637 5.07116 17.637 5.24171C17.637 10.4437 13.6776 16.4376 6.44107 16.4376C4.21162 16.4376 2.14058 15.7919 0.398438 14.6712C0.7152 14.7077 1.01974 14.7199 1.34869 14.7199C3.18825 14.7199 4.88168 14.0986 6.23396 13.0387C4.50401 13.0021 3.05426 11.8691 2.55476 10.3097C2.79844 10.3462 3.04208 10.3706 3.29794 10.3706C3.65123 10.3706 4.00455 10.3219 4.33346 10.2366C2.53043 9.87112 1.1781 8.28739 1.1781 6.3747V6.32599C1.70194 6.61837 2.31113 6.80111 2.95676 6.82545C1.89686 6.11884 1.20248 4.91276 1.20248 3.54829C1.20248 2.81734 1.39736 2.14729 1.7385 1.56251C3.67556 3.95032 6.58725 5.50969 9.85219 5.68027C9.79129 5.38789 9.75473 5.08335 9.75473 4.77877C9.75473 2.61023 11.5091 0.84375 13.6898 0.84375C14.8227 0.84375 15.8461 1.31888 16.5649 2.08639C17.4542 1.91584 18.307 1.58689 19.0623 1.13614C18.7699 2.04986 18.1486 2.81737 17.3324 3.30465C18.1243 3.21941 18.8918 3.00007 19.5984 2.69554C19.0624 3.4752 18.3923 4.16959 17.6248 4.73002Z",
    fill: "#191916"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLightIcon);
export default __webpack_public_path__ + "static/media/twitterLightIcon.3feb378be860cbca09cfbf508b677dd3.svg";
export { ForwardRef as ReactComponent };